// src/components/SEO.jsx
// Drop <SEO /> into any page to set title, description, OG tags, etc.
// Requires: npm install react-helmet-async
// Wrap your <App /> in <HelmetProvider> (see index.js instructions below)

import { Helmet } from 'react-helmet-async'

const SITE_NAME = 'RaStegHub'
const SITE_URL  = 'https://rasteghub.co.ke'
const SITE_DESC = 'RastegHub is a product-driven tech innovation hub based in Nairobi, Kenya. We build impactful software, SaaS products, and digital solutions for businesses and individuals across Africa.'
const OG_IMAGE  = `${SITE_URL}/og-image.jpg`  // upload a 1200×630 image to public_html/

export default function SEO({
  title,
  description = SITE_DESC,
  url,
  image = OG_IMAGE,
  type = 'website',
  noIndex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Tech Innovation Hub, Nairobi`
  const canonical = url ? `${SITE_URL}${url}` : SITE_URL

  return (
    <Helmet>
      {/* ── Primary ── */}
      <title>{fullTitle}</title>
      <meta name='description' content={description} />
      <link rel='canonical' href={canonical} />
      {noIndex && <meta name='robots' content='noindex, nofollow' />}

      {/* ── Open Graph (Facebook, WhatsApp, LinkedIn) ── */}
      <meta property='og:type'        content={type} />
      <meta property='og:title'       content={fullTitle} />
      <meta property='og:description' content={description} />
      <meta property='og:url'         content={canonical} />
      <meta property='og:image'       content={image} />
      <meta property='og:site_name'   content={SITE_NAME} />
      <meta property='og:locale'      content='en_KE' />

      {/* ── Twitter Card ── */}
      <meta name='twitter:card'        content='summary_large_image' />
      <meta name='twitter:title'       content={fullTitle} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image'       content={image} />

      {/* ── Geo tags (helps local SEO for Nairobi) ── */}
      <meta name='geo.region'       content='KE-30' />
      <meta name='geo.placename'    content='Nairobi' />
      <meta name='geo.position'     content='-1.286389;36.817223' />
      <meta name='ICBM'             content='-1.286389, 36.817223' />

      {/* ── Additional ── */}
      <meta name='author'    content='RastegHub' />
      <meta name='copyright' content='RastegHub' />
    </Helmet>
  )
}